<template>
  <v-card flat class="dt-border pad-10">
    <v-container>
      <v-row>
        <v-col class="box-title" cols="12" md="8">
          <div>
            <h2 class="card-title font-weight-bold">Giftcard Trades</h2>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <v-menu
              v-model="menu"
              style="box-shadow: none"
              :close-on-content-click="false"
              :close-on-click="true"
              :nudge-width="100"
              max-width="300"
              class="menu dt-border"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  outlined
                  rounded
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-filter-variant </v-icon>
                  filter
                </v-btn>
              </template>
              <v-card class="pa-5" flat>
                <label for="">Status</label>
                <v-select
                  :items="statusList"
                  v-model="status"
                  item-text="text"
                  item-value="key"
                  dense
                  outlined
                  return-object
                ></v-select>
                <label for="">Date</label>
                <br />
                <DateRangePicker v-model="dateRange" />
                <v-card-actions>
                  <v-btn rounded depressed @click="reset">Reset</v-btn>
                  <v-btn color="primary" @click="reload()" rounded depressed
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-row class="pl-5">
        <div>
          <span
            v-if="transactions.total != 0 && this.loading == false"
            class="dt-orange white--text pa-2 rounded"
            >{{ transactions.total }} transactions</span
          >
        </div>
        <v-spacer></v-spacer>
        <dtunes-pagination
          @reload="reload"
          @nextPage="pageChangeHandle('next')"
          @previousPage="pageChangeHandle('previous')"
          :rows="rows"
          :limit="limit"
          :page="page"
          :totalPage="totalPage"
        />
      </v-row>
      <br /><br />
      <v-row v-if="transactions.data.length > 0">
        <v-col v-for="(transaction, i) in transactions.data" :key="i" cols="12">
          <v-card flat class="transaction-box dt-border pad-10" align="center">
            <v-row align="center" justify="center">
              <v-col style="align-items:center;justify-content:center;display:flex">
                <img
                  width="30"
                  height="30"
                  :src="transaction.store.icon"
                />
              </v-col>
              <v-col>
                <span><b>{{ transaction.reference }}</b></span>
              </v-col>
              <v-col>
                <p>{{ formatDate(transaction.created)}}</p>
              </v-col>
              <v-col>
                <p>{{ formatTime(transaction.created)}}</p>
              </v-col>
              <v-col>
                <p v-if="transaction.loaderAmount">{{ transaction.loaderAmount}}</p>
                <p v-else>{{ transaction.userAmount }}</p>
              </v-col>
              <v-col>
                <p :class="color(transaction.status)"><b>{{ transaction.status }}</b></p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <dtunes-empty v-else>
        <template v-slot:title>
          No Giftcard Trade yet
        </template>
      </dtunes-empty>
    </v-container>
  </v-card>
</template>

<script>
// ============ IMPORT COMPONENT  ==============
import DtunesEmpty from "@/components/dtunes-empty.vue"
import DtunesPagination from "@/components/dtunes-pagination.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

// =========== IMPORT SERVICES =========
import { parseTimestamp } from '@/utils/dates'
import { UsersService } from '@/services';

export default {
    // props: {
    //   transactions: Object
    // },
    data: () => ({
      menu: false,
      loading: false,
      transactions: {},
      rows: [20, 50, 100],
      totalPage: 0,
      page: 1,
      limit: 20,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      statusList: [
        {
          text: "All",
          key: null,
        },
        {
          text: "Waiting",
          key: 'waiting',
        },
        {
          text: "Processing",
          key: 'processing',
        },
        {
          text: "Approved",
          key: 'approved',
        },
        {
          text: "Declined",
          key: 'declined',
        },
      ],
      status: {
        text: "All",
        key: null,
      },
    }),
    components:{
      DtunesEmpty,
      DateRangePicker,
      DtunesPagination
    },
    computed:{
      
    },
    mounted(){
      this.getTransactions()
    },
    methods:{
      async getTransactions(){
        try {
          let filter = {
            status: this.status.key,
            startDate: this.dateRange.startDate,
            endDate: this.dateRange.endDate
          }
          this.loading = true
          const data = await UsersService.viewUsersTrades({
            id: this.$route.params.id,
            page: this.page,
            limit: this.limit,
            filters: this.cleanUpFilter(filter)
          });
          this.transactions = data
          this.loading = false
        } catch (error) {
          this.loading = false
        }
        this.totalPage = Math.ceil(this.transactions.total / this.limit);
      },
      async reload(value) {
        if (value) {
          this.limit = value;
        }
        await this.getTransactions();
        this.menu = false;
      },

      cleanUpFilter(obj) {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === null || obj[key] === "") {
            delete obj[key];
          }
        });
        let check = Object.keys(obj).length === 0;
        return check ? null : obj;
      },
      reset() {
        this.status = this.statusList[0];
        this.dateRange = {
          startDate: null,
          endDate: null,
        };
        this.getTransactions();
        this.menu = false;
      },
      async pageChangeHandle(value) {
        switch (value) {
          case "next":
            this.page += 1;
            break;
          case "previous":
            this.page -= 1;
            break;
          default:
            this.page = value;
        }
        this.getTransactions();
      },
      formatDate(date){
        let d = new Date(date)
        let reModelDate = d.toLocaleString(["en-Us"], {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        return reModelDate;
      },
      formatTime(time){
        return parseTimestamp(new Date(time), 'HH:mm')
        // return time
      },
      color(status){
        let color;
        if(status == 'approved'){
          color = 'green--text'
        }
        if(status == 'declined'){
          color = 'red--text'
        }
        if(status == 'processing'){
          color = 'blue--text'
        }
        if(status == 'waiting'){
          color = 'orange--text'
        }
        return color
      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
p{
    margin-bottom: unset;
}
.card-title{
    font-size: 20px;
    color: $Dtunes-text;
    letter-spacing: 1px;
}

.transaction-box{
    // box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.08);
    // margin-bottom:10px;
    background:$Dtunes-offwhite;
    color: $Dtunes-text;
}
p,span{
  font-size: 14px;
}
select{
    // border: 0.8px solid #000000;
    -webkit-appearance: menulist !important;
    border-radius: 5px;
    padding:5px 10px;
    color: #656565;
    outline: none !important;
}
</style>